export const views = {
    MAIN_PAGE: "MAIN_PAGE",
    LOGIN_PAGE: "LOGIN_PAGE",
    REGISTRATION_PAGE: "REGISTRATION_PAGE",
    CHAMPIONSHIPS_PAGE: " CHAMPIONSHIPS_PAGE",
    RATING_PAGE: "RATING_PAGE",
    ABOUT_PAGE: "ABOUT_PAGE",
    RESET_PASSWORD_PAGE: "RESET_PASSWORD_PAGE",
    USER_PAGE: "USER_PAGE",
    CHAMPIONSHIP_PAGE: "CHAMPIONSHIP_PAGE",
    USER_LOGIN_PAGE: "USER_LOGIN_PAGE",
    ADMIN_PAGE: "ADMIN_PAGE",
    VACANCY_PAGE: "VACANCY_PAGE",
    FORUM_PAGE: "FORUM_PAGE"
};



// WEBPACK FOOTER //
// src/constants/views.jsx